/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { dataLayerPush } from '../helpers/dataLayer';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { addItemToLocalStorage } from '../helpers/handleCartLocalStorage';
import { Link } from 'react-router-dom';
import { Navbar, Carousel } from '../components';

const Products = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState(localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []);
  let componentMounted = true;

  const addProduct = (product) => {
    dataLayerPush({
      event: 'addToCart',
      pageName: 'home',
      pageType: 'listing',
      product: product,
    });
    addItemToLocalStorage(product);
    setState(JSON.parse(localStorage.getItem('cart')));
  };

  useEffect(() => {
    const getProducts = async () => {
      setLoading(true);
      const response = await fetch('product.json', {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });
      if (componentMounted) {
        setData(await response.clone().json());
        setLoading(false);
      }
    };

    getProducts();
  }, [componentMounted]);

  useEffect(() => {
    dataLayerPush({
      event: 'pageView',
      pageType: 'listing',
      pageName: 'home',
    });
  }, []);

  const Loading = () => {
    return (
      <>
        <div className='col-12 py-5 text-center'>
          <Skeleton />
        </div>
        <div className='col-md-4 col-sm-6 col-xs-8 col-12 mb-4'>
          <Skeleton />
        </div>
        <div className='col-md-4 col-sm-6 col-xs-8 col-12 mb-4'>
          <Skeleton />
        </div>
        <div className='col-md-4 col-sm-6 col-xs-8 col-12 mb-4'>
          <Skeleton />
        </div>
        <div className='col-md-4 col-sm-6 col-xs-8 col-12 mb-4'>
          <Skeleton />
        </div>
        <div className='col-md-4 col-sm-6 col-xs-8 col-12 mb-4'>
          <Skeleton />
        </div>
        <div className='col-md-4 col-sm-6 col-xs-8 col-12 mb-4'>
          <Skeleton />
        </div>
      </>
    );
  };

  const ShowProducts = () => {
    return (
      <>
        {data.map((product) => {
          return (
            <div id={product.id} key={product.id} className='col-md-3 col-sm-6 col-xs-8 col-12 pb-3'>
              <div className='card text-center h-100 border-0 product-card' key={product.id}>
                <Link to={'/product/' + product.id} className='stretched-link' />
                <img src={product.images.main} className='rounded-1' alt='main image' />
                <button
                  className='btn btn-light w-75 mx-auto m-1 addToCart bottom-10 position-relative btn-sm border-0'
                  style={{ bottom: '8%', zIndex: 1 }}
                  onClick={(e) => {
                    e.preventDefault();
                    addProduct(product);
                  }}>
                  Add to Cart
                </button>
                <div className='d-flex'>
                  <p className='mb-0 fw-light'>{product.title}</p>
                  <p className='ms-auto mb-0 fw-light'>{product.sub}</p>
                </div>
                <div className='d-flex'>
                  <p className='mt-0'>$ {product.price}</p>
                  <a href={'/product/' + product.id} className='ms-auto mt-0 primary-color'>
                    Buy Now
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  };
  return (
    <>
      <Navbar />
      <Carousel />
      <div className='container my-3 py-3'>
        <div className='row justify-content-center'>{loading ? <Loading /> : <ShowProducts />}</div>
      </div>
    </>
  );
};

export default Products;
